export default "__VITE_ASSET__CmZk8yY4__$_?v=2__"